<template>
  <div class="certification">
    <div class="certification-container">
      <div class="title"></div>
      <div class="manu">
        <img src="../../../../assets/moblie/images/manu.png" />
      </div>
      <div class="content">
        五福化学制药有限公司创立于1951年，是台湾知名眼用药研发生产厂家。自成立以来，五福公司
        在眼用药品领域上精耕细作，陆续研发上市了滴目露、特必达、乐拓品等近20种畅销海内外眼用药
        水。其中0.05%乐拓品系列为全球首家且独家的0.05%阿托品滴眼液厂家。
      </div>
      <div class="time-line">
        <div class="time-line-item">
          <div class="time">1976年</div>
          <div class="event">
            全球第一款1%阿托品滴眼液在日本获批上市
          </div>
        </div>
        <div class="time-line-item">
          <div class="time">1980年</div>
          <div class="event">
            五福公司开始生产阿托品滴眼液，是全球第二家阿托品生产厂家
          </div>
        </div>
        <div class="time-line-item">
          <div class="time">2004年</div>
          <div class="event">
            五福公司的0.01%阿托品滴眼液外销新加坡
          </div>
        </div>
        <div class="time-line-item">
          <div class="time">2018年</div>
          <div class="event">
            五福公司研发的全球首款0.05%阿托品滴眼液获批上市
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ListingCertification",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {};
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.certification {
  min-height: 100%;
  background-color: rgb(72, 173, 241);
  padding: 15px 20px;
  overflow: auto;
  &-container {
    background-color: #fff;
    border-radius: 14px;
    min-height: 100%;
    overflow: auto;
    padding: 15px 15px;
    .title {
      background-image: url("../../../../assets/moblie/images/manutitle.png");
      background-size: 100% 100%;
      width: 80%;
      height: 1.5rem;
      margin: 0 auto;
    }
    .manu {
      width: 100%;
      height: 120px;
      margin-top: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      margin-top: 10px;
      font-size: 17px;
      line-height: 28px;
      margin-bottom: 10px;
    }
    .time-line {
      &-item {
        padding: 20px 15px;
        position: relative;
        border-left: 1px solid rgb(46, 119, 196);
        .time {
          font-size: 18px;
          font-weight: 600;
          line-height: 26px;
        }
        .event {
          font-size: 16px;
        }
      }
      &-item::after {
        content: "";
        width: 10px;
        height: 10px;
        background-color: rgb(46, 119, 196);
        box-shadow: 0 0 2px 2px rgb(164, 198, 230);
        position: absolute;
        left: -5px;
        top: 27px;
        border-radius: 40px;
      }
    }
  }
}
</style>
